export enum GeneralTranscription {
  LOADING_TEXT = 'Cargando, por favor espere...',
  SELECT = 'Seleccionar',
  EDIT = 'Editar',
  DELETE = 'Eliminar',
  MANDATORY = '(obligatorio)',
  OTHER = 'Otro',
  ACTIVE = 'Activo',
  INACTIVE = 'Inactive',
  SAVE = 'Guardar',
  YES = 'Si',
  NO = 'No',
  SEND = 'Enviar',
  USER = 'Usuario',
  ASC = 'Ascendente',
  DESC = 'Descendente',
  NAME = 'Nombre',
  CANCEL = 'Cancelar',
  ADD = 'Agregar',
  EMPTY_RESULTS = 'Sin resultados',
  HOME = 'Home',
  SEARCH = 'Buscar',
  TOTAL = 'Total: #amount',
  CONTINUE = 'Continuar',
  DATE = 'Fecha',
  OPTIONS = 'Opciones',
  STATUS = 'Estado',
  ADDRESS = 'Dirección',
  RETRY = 'Reintentar',
  ERROR_MESSAGE = 'Ocurrió un error inesperado',
  ERROR_LOADING_APP = 'Error al cargar la aplicación',
  HOME_ERROR = 'No se pudo cargar el home, por favor intente nuevamente',
  FEATURED = 'Destacado',
  ERROR_TOO_MANY_REQUESTS = 'Demasiados intentos, por favor intente más tarde',
  ERROR_NETWORK = 'Problemas con la red, por favor intente nuevamente',
}

export enum AuthTranscription {
  FORM_EMAIL_PLACEHOLDER = 'Correo',
  FORM_PASSWORD_PLACEHOLDER = 'Contraseña',
  FORM_RECOVER_PASSWORD_TEXT = 'Recuperar Contraseña',
  FORM_REGISTER_REPEAT_PASSWORD_TEXT = 'Reptite la contraseña',
  FORM_LOGIN_TEXT = 'Iniciar Sesión',
  FORM_LOGIN_FECHING = 'Iniciando Sesión...',
  FORM_REGISTER_TEXT = 'Registrarse',
  ERROR_EMPTY_MAIL_RULE = 'Por favor ingresa tu email',
  ERROR_FORMAT_MAIL_RULE = 'Ingresa un email válido',
  ERROR_EMPTY_PASSWORD_RULE = 'Por favor ingresa tu contraseña',
  ERROR_TYPE_PASSWORD_RUlE = 'Contaseña no válida',
  ERROR_JWT_EXPIRED_RETRY_LOGIN = 'Su sesión ha expirado, por favor ingrese nuevamente',
  RECOVER_PASSWORD_SENT_TOKEN = 'Recibirás un correo a #mail si la dirección existe en nuestros registros.',
  ERROR_PASSWORD_MIN = 'Contraseña demasiado corta',
  ERROR_PASSWORD_MAX = 'Contraseña demasiado largo',
  ERROR_REPEAT_PASSWORD_NOT_MATCH = 'Las contraseñas no coinciden',
  FORM_RESET_PASSWORD_TEXT = 'Resetear Contraseña',
  RESET_PASSWORD_SUCCESSFULL = 'Su contraseña ha sido modificada de forma exitosa',
  LOGOUT = 'Cerrar Sesión',
  UNKNOWN_LOGIN_ERROR = 'Error desconocido al iniciar sesión, por favor intente nuevamente',
  ERROR_LOGOUT = 'No se pudo cerrar sesión, por favor intente nuevamente',
  ERROR_RECOVER_PASSWORD = 'Ocurrió un error al recuperar la contraseña, por favor intente nuevamente.',
  ERROR_INVALID_CREDENTIALS = 'Usuario o contraseña incorrecta',
  ERROR_JWT_EXPIRED = 'Su sesión ha expirado, por favor intente nuevamente',
  ERROR_UNAUTHORIZED = 'Ocurrió un error, por favor intente nuevamente',
  ERROR_JWT_NOT_ACEPTED = 'Token inválido',
  AUTH_REQUIRED_TO_CONTINUE = 'Inicia sesión para continuar',
}

export enum NotFoundTranscription {
  NOT_FOUND_TITLE = 'Ups... Página no encontrada',
  NOT_FOUND_SUBTITLE = 'Lo sentimos!, La página que buscas no existe. Revisa la dirección que ingresaste y vuelvelo a intentar.',
  NOT_FOUND_BUTTON_HOME_TEXT = 'Volver al inicio',
  NOT_FOUND_USER_PURCHASES_TITLE = 'No se encontraron compras.',
  NOT_FOUND_PURCHASE_DETAIlS_TITLE = 'No se encontro la compra.',
  NOT_FOUND_PURCHASE_DETAILS_SUBTITLE = 'La compra a la que estás accedediendo no existe.',
}

export enum MiniCartTranscription {
  MINI_CART_DRAWER_TITLE = 'Mi Carro',
  MINI_CART_TOOLTIP_TITLE = 'Ver los productos en mi carro',
}

export enum UserTranscription {
  USER_MY_INFO = 'Mis datos',
  USER_MY_PROFILE = 'Mi perfil',
  USER_MY_FAVORITES = 'Mis favoritos',
  USER_MY_PURCHASES = 'Mis compras',
  EDIT_INFO = 'Editar datos',
  USER_GENRE_MALE = 'Masculino',
  USER_GENRE_FEMALE = 'Femenino',
  EDIT_USER_INFO = 'Editar mis datos',
  USER_NAME = 'Nombre',
  USER_NAME_RULE_REQUIRED = 'Ingrese un nombre',
  USER_NAME_RULE_TYPE = 'Nombre no válido',
  USER_NAME_RULE_MIN = 'El nombre es demasiado corto',
  USER_NAME_RULE_MAX = 'El nombre es demasiado largo',
  USER_NAME_PLACEHOLDER = 'Ej: Benjamin Jhon',
  USER_LAST_NAME = 'Apellido',
  USER_LAST_NAME_RULE_REQUIRED = 'Ingrese un apellido',
  USER_LAST_NAME_RULE_TYPE = 'Apellido no válido',
  USER_LAST_NAME_RULE_MIN = 'El apellido es demasiado corto',
  USER_LAST_NAME_RULE_MAX = 'El apellido es demasiado largo',
  USER_LAST_NAME_PLACEHOLDER = 'Ej: Smith Clark',
  USER_DNI = 'Rut',
  USER_DNI_REQUIRED = 'Ingrese un rut',
  USER_DNI_RULE_TYPE = 'Rut no válido',
  USER_DNI_PLACEHOLDER = 'Ej: 11.111.111-2',
  USER_EMAIL = 'Correo',
  USER_EMAIL_REQUIRED = 'Ingrese un correo',
  USER_EMAIL_RULE_TYPE = 'Correo no válido',
  USER_EMAIL_PLACEHOLDER = 'Ej: mi-mail@mail.com',
  USER_EMAIL_RULE_MIN = 'Correo demasido corto',
  USER_EMAIL_RULE_MAX = 'Correo demasiado largo ',
  USER_PHONE = 'Teléfono',
  USER_PHONE_REQUIRED = 'Ingrese un teléfono',
  USER_PHONE_RULE_TYPE = 'Teléfono no válido',
  USER_PHONE_PLACEHOLDER = 'Ej: 911112233',
  USER_PHONE_RULE_MIN = 'Teléfono demasido corto',
  USER_PHONE_RULE_MAX = 'Teléfono demasiado largo ',
  USER_GENRE = 'Género',
  USER_GENRE_RULE_REQUIRED = 'Seleccione un género',
  USER_GENRE_PLACEHOLDER = 'Seleccione un género',
  USER_BIRTH_DATE = 'Fecha de nacimiento',
  USER_BIRTH_DATE_RULE_REQUIRED = 'Seleccione una fecha',
  USER_BIRTH_DATE_PLACEHOLDER = 'Seleccione una fecha',
  USER_BIRTH_DATE_RULE_TYPE = 'Fecha no válida',
  SAVING_USER_INFO = 'Actualizando información, por favor espere...',
  COMPLETE_PROFILE_DATA_TEXT = 'Estimado #mail, si desea realizar una compra, le informamos que debe completar su perfil de usuario con la información faltante. Gracias!',
  EMPTY_FAVORITES = 'No se han agregado favoritos.',
  FAVORITES_MAX_ITEMS = 'Usted ha seleccionado el máximo de favoritos.',
  FETCHING_FAVORITES = 'Obteniendo Favoritos, por favor espere...',
  ADDING_TO_FAVORITES = 'Añadiendo a favoritos...',
  REMOVING_FROM_FAVORITES = 'Quitando de favoritos...',
  PURCHASE_DETAILS = 'Detalles de compra',
  PURCHASE_ADDRESS_SELECTED = 'Dirección usada para esta compra',
  PURCHASE_CHANGE_ADDRESS = 'Modificar dirección',
  PURCHASE_DATA = 'Datos de compra',
  PAYMENT_DATA = 'Información de pago',
  PURCHASE_ITEM_PRODUCTS = 'Productos incluidos en esta compra',
  FINALIZE_YOUR_PURCHASE = 'Finaliza tu compra',
  GO_TO_MY_PURCHASES = 'Ir a mis compras',
  ERROR_FETCHING_USER_PROFILE = 'Error al obtener el perfil de usuario',
  ERROR_UPDATING_USER_PROFILE = 'Error al actualizar el perfil de usuario',
  ERROR_GET_USER_PURCHASES = 'No se pudo obtener el listado de compras',
  ERROR_GETTING_FAVORITES = 'No se pudo obtener el listado de favoritos',
  ERROR_USER_NOT_FOUND = 'Usuario no encontrado',
  ERROR_PLEASE_WAIT_3_MINS_TO_GET_ANOTHER_RECOVER_PASSWORD_MAIL = 'Puedes volver a intentar recuperar tu contraseña en 3 minutos.',
  ERROR_USER_HAS_MAX_FAVORITES_ADDED = 'Ya has alcanzado el número máximo fvoritos agregados',
  ERROR_INVALID_DNI = 'Documento no válido',
  FAVORITE_UPDATED = 'Favoritos actualizados correctamente',
}

export enum AddressTranscription {
  MY_ADDRESSES = 'Mis direcciones',
  CURRENT_ADDRESS_TEXT = 'Tu dirección actual es:',
  NO_SELECTED_ADDRESS = 'No seleccionada',
  NEW_ADDRESS = 'Agregar dirección',
  EDIT_ADDRESS = 'Modificar dirección',
  UPDATING_ADDRESS = 'Estamos actualizando tus direcciones, un momento!',
  SELECT_ADDRESS = 'Seleccionar dirección',
  SELECT_ADDRESS_CONFIRMATION = '¿Desea seleccionar como su dirección actual?',
  SELECTED_SUCCES_ADDRESS = 'Dirección seleccionada con éxito!',
  DELETE_ADDRESS = 'Eliminar dirección',
  DELETE_ADDRESS_CONFIRMATION = '¿Está seguro de que desea borrar esta dirección?',
  DELETED_SUCCES_ADDRESS = 'Dirección eliminada con éxito!',
  STATE = 'Región',
  STATE_RULE_REQUIRED = 'Selecciona una región válida',
  STATE_PLACEHOLDER = 'Selecciona una región',
  COMUNA = 'Comuna',
  COMUNA_PLACEHOLDER = 'Selecciona una comuna',
  COMUNA_RULE_REQUIRED = 'Selecciona una comuna válida',
  CITY = 'Ciudad',
  STREET = 'Calle',
  STREET_RULE_MIN = 'El nombre de la calle es muy corto',
  STREET_RULE_MAX = 'El nombre de la calle es muy largo',
  STREET_RULE_REQUIRED = 'Ingresa una calle válida',
  STREET_PLACEHOLDER = 'Ej: Avenida Vicuña Mackenna',
  STREET_NUMBER = 'Número de calle',
  STREET_NUMBER_PLACEHOLDER = 'Ej: 1004',
  STREET_NUMBER_RULE_MIN = 'Ingresa por lo menos 1 caracter',
  STREET_NUMBER_RULE_MAX = 'Número de calle demasiado largo',
  STREET_NUMBER_RULE_REQUIRED = 'Ingresa un número de calle válido',
  BLOCK_NUMBER = 'Número de casa / departamento',
  BLOCK_NUMBER_PLACEHOLDER = 'Ej: 204-C',
  BLOCK_NUMBER_RULE_MIN = 'Ingresa por lo menos 1 caracter',
  BLOCK_NUMBER_RULE_MAX = 'Número de casa / apartamento demasiado largo',
  BLOCK_NUMBER_RULE_REQUIRED = 'Ingresa una información válida',
  SET_AS_CURRENT_ADDRESS = 'Establecer como dirección actual:',
  SAVE_ADDRESS = 'Guardar dirección',
  SAVING_ADDRESS = 'Guardando dirección, por favor espere...',
  MAX_ADDRESS_CREATED = 'Atención! ha creado el máximo de direcciones permitidas. Si desea agregar una nueva, elimine alguna existente.',
  ERROR_FETCHING_LOCATIONS = 'Error al obtener las ubicaciones',
  ADDRESS_SAVED_SUCCESSFULLY = 'Dirección guardada correctamente',
}

export enum CatalogTranscription {
  SEARCH_INPUT_PLACEHOLDER = '¿Que estás buscando?',
  SEARCH_RESULTS_TITLE = 'Resultados para #searchTerm',
  SORT_BY = 'Ordenar Busqueda por',
  FOUND_RESULTS = 'Resultados encontrados',
  PRODUCT_PRICE = 'Precio',
  PRODUCT_BRAND = 'Marca',
  FILTERS = 'Filtrar por:',
  APPLY_FILTERS = 'Aplicar Filtros',
  CLEAR_FILTERS = 'Borrar filtros',
  SEARCH_NO_RESULTS_TITLE = 'Sin resultados',
  SEARCH_NO_RESULTS_SUBTITLE = 'Prueba con otra búsqueda, por ejemplo: Polera',
  ADD_TO_FAVORITES = 'Añadir a favoritos',
  ADD_TO_CART = 'Añadir al carro',
  PRODUCT_NEW = 'Nuevo',
  PRODUCT_VOTES = 'votos',
  PRODUCT_CODE = 'Código del producto',
  PRODUCT_SERIAL_CODE = 'Código serial',
  PRODUCT_PRICE_FROM = 'Desde',
  PRODUCT_PRICE_PER_UNIT = 'c/u',
  EMPTY_CART_TEXT = 'Su carro está vacio.',
  GO_TO_PAY = 'Ir a pagar',
  CONFIRM_TO_DELETE_FROM_CART = 'Está seguro que desea eliminar del carro ?',
  ADDED_TO_CART = 'En el carro',
  ADDED_TO_FAVORITES = 'Se añadió favoritos, click para quitar.',
  CHOOSE_AN_OPTION = 'Elige una opción',
  IN_FAVORITES = 'Favorito',
  REMOVE_FROM_FAVORITES = 'Quitar de favoritos',
  SELECTED_OPTION = 'Opción seleccionada',
  OUT_OF_STOCK_VARIANT = 'Sin stock',
  DELETE_PRODUCT_FROM_CART = 'Eliminar del carro',
  SOME_ITEMS_OUT_OF_STOCK = 'Algunos productos no se encuentran disponibles, por favor remuévelos para continuar',
  ERROR_DELETING_PRODUCT_FROM_CART = 'Error al eliminar el producto del carro',
  ERROR_GETTING_PRODUCT_DETAILS = 'Error al obtener los detalles del producto',
  ERROR_GETTING_FACETS = 'Error al obtener los filtros',
  ERROR_GETTING_PRODUCTS = 'Error al obtener los productos',
}

export enum OrderTranscription {
  PURCHASE_RESULT = 'Resultado de compra',
  ORDER_NUMBER = 'Número de pedido',
  PAYMENT_METHOD = 'Método de pago',
  PICKUP = 'Retiro en tienda',
  DELIVERY = 'Envio a domicilio',
  DELIVERY_TYPE = 'Tipo de entrega',
  BUYER_NOTE = 'Nota adicional',
  RETRY_PURCHASE = 'Reintentar Compra',
  AUTHORIZATION_CODE = 'Código de authorización',
  INSTALLMENTS_NUMBER = 'Número de cuotas',
  INSTALLMENTS_AMOUNT = 'Monto de cuotas',
  CARD_NUMBER = 'Número de tarjeta',
  PAYMENT_NOTES = 'Nota adicional de pago',
  INCLUDED_ITEMS = 'Productos incluidos en la compra',
  ADDRESS_SELECTED = 'El envio será a esta dirección',
  PURCHASE_ABORTED = 'Compra cancelada.',
  PURCHASE_TIMEOUT = 'Tiempo agotado.',
  PURCHASE_NOT_ACCEPTED = 'Su pago no ha sido aceptado.',
  PURCHASE_LIST = 'Listado de compras',
  TRANSACTION_ID = 'Id de transacción',
  PURCHASE_STATUS_DELIVERED = 'Entregado',
  PURCHASE_STATUS_PENDING = 'Pendiente',
  PURCHASE_STATUS_NO_APPLY = 'Retiro en tienda',
  NEWEST_FIRST = 'Recientes primero.',
  OLDERS_FIRST = 'Antiguas primero.',
  PAY = 'Pagar',
  SUBTOTAL = 'Subtotal',
  TOTAL = 'Total',
  PURCHASE_SUMMARY = 'Resumen de compra',
  PLACEHOLDER_BUYER_NOTE = 'Ej: Dejar en conserjería, timbre malo...',
  PLACEHOLDER_COUPON = '¿Tienes un cupón?',
  PICKUP_NOT_AVAILABLE = 'Retiro en tienda no disponible',
  DELIVERY_NOT_AVAILABLE = 'Envio a domicilio no disponible',
  ERROR_VALIDATING_COUPON = 'Error al validar el cupón',
  ERROR_MERGE_CART = 'Error al fusionar el carro',
  ERROR_CHECK_USER_CART = 'Error al obtener el carro',
  ERROR_SYNC_CART = 'Error al sincronizar el carro',
  ERROR_DISCARD_CART = 'Error al vaciar el carro',
  ERROR_RETRIEVING_CHECKOUT = 'Error al obtener el checkout',
  DISCARD_CART = 'Vaciar carro',
  DISCARD_CART_CONFIRMATION = '¿Está seguro que desea vaciar el carro?',
  ERROR_INIT_PURCHASE = 'Error al iniciar la compra',
  ERROR_IDEMPOTENCY_KEY_INVALID = 'La llave de idempotencia no es válida',
  ERROR_IDEMPOTENCY_CONFLICT = 'Esta llave de pago corresponde a otra compra. Genera un nuevo intento.',
  ERROR_IDEMPOTENCY_IN_PROGRESS = 'El pago se está procesando. Espera un momento.',
  ERROR_BAD_LIFECYCLE_REQUEST = 'No se puede continuar con el pago en el estado actual',
  ERROR_ORDER_ALREADY_PAID = 'Esta compra ya fue pagada',
  ERROR_AMOUNT_MISMATCH = 'El monto pagado no coincide con el total de la orden',
  PAYMENT_CONFIRMING = 'Estamos confirmando tu pago. Puedes revisar el estado en Mis compras.',
  GO_TO_MY_PURCHASES = 'Ir a Mis compras',
  ERROR_PROCESSING_PAYMENT = 'Error al procesar el pago',
  PURCHASE_SUCCESSFUL = 'Pago realizado con éxito',
  ERROR_GET_ORDER_DETAILS = 'Error al obtener los detalles de la orden',
  PAYMENT_DATE = 'Fecha de compra',
  DELIVERY_STATUS = 'Estado de entrega',
  BOLETA_ELECTRONICA = 'Boleta electrónica',
  BOLETA_FOLIO = 'Folio',
  DOWNLOAD_BOLETA = 'Descargar boleta',
  OPENING_BOLETA = 'Abriendo boleta...',
  ERROR_DOWNLOAD_BOLETA = 'No se pudo abrir la boleta',
  NEXT_STEPS_TITLE = '¿Qué sigue ahora?',
  NEXT_STEPS_EMAIL_NOTE = 'Te enviaremos un correo con el detalle a',
  NEXT_STEPS_1 = 'Estamos preparando tu pedido con mucho cariño.',
  NEXT_STEPS_DELIVERY = 'Recibirás una notificación cuando el repartidor vaya en camino.',
  NEXT_STEPS_PICKUP = 'Te avisaremos apenas esté listo para que pases a retirarlo por la tienda.',
  BUYER_NOTES = 'Tus notas para el pedido',
}

export enum FooterTranscription {
  HELP_CENTER = 'Centro de ayuda',
  ORDER_TRACKING = 'Seguimiento de compras',
  PICKUP = 'Retiro en tienda',
  CONTACT = 'Contáctanos',
  HELP = 'Ayuda',
  HOW_TO_BUY = 'Cómo comprar',
  SHIPPING_AND_PICKUP = 'Envíos y retiro',
  PAYMENT_METHODS = 'Medios de pago',
  MY_ACCOUNT = 'Mi cuenta',
  ABOUT_STORE = 'La tienda',
  ABOUT_US = 'Quiénes somos',
  TERMS = 'Términos y condiciones',
  PRIVACY = 'Política de privacidad',
  FOLLOW_US = 'Síguenos',
  COMING_SOON = 'Próximamente',
  ALL_RIGHTS_RESERVED = 'Todos los derechos reservados',
}

export enum PreHeaderTranscription {
  REGION_LABEL = 'Información de la tienda',
  SHIPPING = 'Envíos a domicilio',
  PICKUP = 'Retiro en tienda',
  WHATSAPP = 'Escríbenos',
  WHATSAPP_ARIA = 'Escríbenos por WhatsApp',
}
